import { ITableField } from 'shared/Table'
import { IProtectionTemplate } from '../protection.types'

const ProtectionTableFields: ITableField<IProtectionTemplate, keyof IProtectionTemplate>[] = [
  { key: 'id', getter: (item) => item.id.toString(), sortGetter: (item) => item.id, header: 'ID', width: '200px' },
  {
    key: 'name',
    getter: (item) => item.name.toString(),
    sortGetter: (item) => item.name,
    header: 'Название',
    width: '300px',
  },
  {
    key: 'description',
    getter: (item) => item.description.toString(),
    sortGetter: (item) => item.description,
    header: 'Описание',
    width: '300px',
  },
]

export default ProtectionTableFields
